import React from "react"

import { graphql } from "gatsby"

export const query = graphql`
  fragment ArticleRelatedContentAssetFields on DatoCmsRelatedContentAsset {
    id
    title
    asset {
      url
      urlJpgImage: url(imgixParams: { fm: "jpg" })
      format
      isImage
    }
    model {
      apiKey
    }
  }
  fragment ArticleRelatedContentLinkFields on DatoCmsRelatedContentLink {
    id
    title
    url
    model {
      apiKey
    }
  }
`
import {
  ArticleRelatedContentAssetFieldsFragment,
  ArticleRelatedContentLinkFieldsFragment,
} from "../../../graphql-types"

const ArticleRelatedContentItem: React.FC<{
  format: string
  url: string
  text: string
}> = ({ format, url, text }) => {
  return (
    <li className={`c-article-related-content__item ${format}`}>
      <a href={url} target="_blank" rel="noreferrer">
        {text}
      </a>
    </li>
  )
}

const ArticleRelatedContent: React.FC<{
  relatedContent: Array<
    | ArticleRelatedContentLinkFieldsFragment
    | ArticleRelatedContentAssetFieldsFragment
  >
}> = ({ relatedContent }) => {
  return (
    <div className="c-article-related-content">
      <h3 className="c-article-related-content__title">Related content</h3>
      <ul>
        {relatedContent.map(relatedContentItem => {
          // Using In-operator narrowing to determine type
          if ("asset" in relatedContentItem) {
            const isImage = relatedContentItem.asset.isImage
            const format = isImage ? "image" : relatedContentItem.asset.format
            const url = isImage
              ? relatedContentItem.asset.urlJpgImage
              : relatedContentItem.asset.url
            return (
              <ArticleRelatedContentItem
                key={relatedContentItem.id}
                format={format}
                url={url}
                text={relatedContentItem.title}
              />
            )
          } else if ("url" in relatedContentItem) {
            return (
              <ArticleRelatedContentItem
                key={relatedContentItem.id}
                format="link"
                url={relatedContentItem.url}
                text={relatedContentItem.title}
              />
            )
          }
        })}
      </ul>
    </div>
  )
}

export default ArticleRelatedContent
